export default __webpack_public_path__ + "static/media/home-about.0000f70f.jpg";